export enum CategorieCritereEnum {

    CATAGORIE_1, CATAGORIE_2, CATAGORIE_3,
    CATAGORIE_4
}
